import apiClient from '@/services/api/apiClient';
import { buildApiUrl } from '../utils';
import {
  GetMediaSocialMediaAddressResponse,
  GetMediaSocialMediaResponse,
  GetPostsViraisByIdResponse,
  GetPostsViraisResponse,
  PostPostsViraisResponse,
  PutMediaSocialMediaResponse,
  PutPostsViraisResponse,
} from '../response/social-media';
import { PutMediaSocialMediaFeedRequest, PutMediaSocialMediaLinkRequest } from '../request/social-media';
import { QueryParams } from '@/model/query-params';

export class SocialMediaService {
  static getSocialMediaAddress() {
    return apiClient.get<GetMediaSocialMediaAddressResponse>(buildApiUrl('/api/v1/media/social-media-address'), undefined);
  }

  static getSocialMedia() {
    return apiClient.get<GetMediaSocialMediaResponse>(buildApiUrl('/api/v1/media/social-media'), undefined);
  }

  static putSocialMedia(data: PutMediaSocialMediaFeedRequest | PutMediaSocialMediaLinkRequest) {
    return apiClient.update<PutMediaSocialMediaResponse>(buildApiUrl('/api/v1/media/social-media'), data);
  }

  static getSocialMediaPostsVirais(params?: QueryParams) {
    return apiClient.get<GetPostsViraisResponse>(buildApiUrl('/api/v1/media/social-media/posts-virais'), params);
  }

  static postPostsVirais(data: any) {
    return apiClient.post<PostPostsViraisResponse>(buildApiUrl('/api/v1/media/social-media/posts-virais'), data);
  }

  static putPostsVirais(id: string, data: any) {
    const url = buildApiUrl('/api/v1/media/social-media/posts-virais/:id', { id });
    return apiClient.update<PutPostsViraisResponse>(url, data);
  }

  static getPostsViraisById(id: string) {
    const url = buildApiUrl('/api/v1/media/social-media/posts-virais/:id', { id });
    return apiClient.get<GetPostsViraisByIdResponse>(url, undefined);
  }

  static deletePostsVirais(id: string) {
    const url = buildApiUrl('/api/v1/media/social-media/posts-virais/:id', { id });
    return apiClient.delete<void>(url, undefined);
  }
}
